import type { Strings } from '../index.ts';

/**
 * Die abgemeldete Fassung von Abos, eigenen Playlists und Verlauf: abgeschaltet mit einem Weg zur
 * Anmeldung, nie kaputt gezeigt.
 *
 * Jeder Eintrag hat eine `anonymous`-Zeile, und darin liegt der Sinn der Sperre: eine Seite, die nur
 * sagt, was fehlt, liest sich als Wand. Was auch ganz ohne Konto geht, macht daraus eine Tür.
 *
 * Kein `*Sternchen*` hier drin: das sind einfache Strings, die als Text gezeichnet werden.
 */
export const gated: Strings['gated'] = {
  subscriptions: {
    title: 'Melde dich an, um deine Abos zu sehen',
    detail:
      'Die Kanäle, denen du folgst, liegen in deinem Konto auf der Instanz und nicht in Visious. Diese Seite braucht dich also angemeldet, bevor sie danach fragen kann.',
    anonymous:
      'Ansehen, Suchen, Kanäle und öffentliche Playlists gehen alle ohne Konto. Diese Seite ist die Ausnahme, weil die Antwort auf dich zugeschnitten ist.',
  },
  playlists: {
    title: 'Melde dich an, um deine Playlists zu sehen',
    detail:
      'Deine eigenen und privaten Playlists liegen in deinem Konto auf der Instanz, und Visious behält bewusst keine Kopie davon: eine Liste, die manchmal deine und manchmal veraltet ist, ist genau der Fehler, den das vermeidet.',
    anonymous:
      'Der Link auf eine öffentliche Playlist öffnet sich weiterhin ohne Anmeldung. Angemeldet sein musst du nur für die Playlists, die dir gehören.',
  },
  history: {
    title: 'Melde dich an, um deinen Verlauf zu sehen',
    detail:
      'Der Wiedergabeverlauf wird auf der Instanz aufgezeichnet, er folgt dir also zwischen Browsern und Geräten. Lesen lässt er sich erst, wenn du angemeldet bist.',
    anonymous:
      'Abgemeldet wird nichts aufgezeichnet, eine abgemeldete Sitzung lässt also auch keinen Verlauf zurück.',
  },
  channels: {
    title: 'Melde dich an, um deine Abos zu verwalten',
    detail:
      'Die Kanäle, denen du folgst, liegen in deinem Konto auf der Instanz. Sie hinzuzufügen und zu entfernen braucht dich also angemeldet.',
    anonymous:
      'Die Kanäle selbst öffnen sich weiterhin ohne Konto. Ihnen zu folgen ist das, was eines braucht.',
  },

  reason: {
    expired: 'Deine Sitzung auf dieser Instanz ist abgelaufen, hier hilft also eine neue Anmeldung.',
    unreadable:
      'Für diese Instanz ist eine Sitzung gespeichert, aber keine, die Visious lesen kann. Eine Anmeldung ersetzt sie.',
    underScoped:
      'Dieser Sitzung fehlen einige der Berechtigungen, um die Visious bittet, deshalb kann diese Seite abgelehnt werden. Die Anmeldeseite sagt, welche es sind, und eine neue Anmeldung bittet um alle.',
  },

  checking: 'Dieser Browser wird auf eine Sitzung geprüft…',
  openSignIn: 'Anmeldeseite öffnen',
  signIn: 'Bei deiner Instanz anmelden',
};
